module.exports = __webpack_public_path__ + "static/codeofhonor1-ed22ca4dfb0bb7bbe18d738831dd8b49.jpeg";